import { api, apiUrl } from "../../../shared/services/service";
import { TfHullEvaluationVessel, TfHullEvaluationsResponse } from "../models/tf-hull-evaluations.models";

type SnowflakeVessel = Record<string, unknown>;

function text(row: SnowflakeVessel, key: string): string {
  return String(row[key] ?? "");
}

function nullableText(row: SnowflakeVessel, key: string): string | null {
  const value = row[key];
  return value === null || value === undefined || value === "" ? null : String(value);
}

function booleanValue(row: SnowflakeVessel, key: string): boolean {
  const value = row[key];

  return value === true || value === 1 || String(value).trim().toLowerCase() === "true";
}

function nullableNumber(row: SnowflakeVessel, key: string): number | null {
  const value = row[key];

  if (value === null || value === undefined || value === "") {
    return null;
  }

  const parsedValue = Number(value);

  return Number.isFinite(parsedValue) ? parsedValue : null;
}

function mapVessel(row: SnowflakeVessel): TfHullEvaluationVessel {
  return {
    imo: text(row, "IMO"), vesselName: text(row, "VESSEL_NAME"),
    vesselEmail: nullableText(row, "VESSEL_EMAIL"), deskEmail: nullableText(row, "DESK_EMAIL"),
    design: text(row, "DESIGN"),
    hasEmailInImos: booleanValue(row, "HAS_EMAIL_IN_IMOS"), techFormStatus: text(row, "TECH_FORM_STATUS"),
    techFormDate: nullableText(row, "TECH_FORM_DATE"), znLink: nullableText(row, "ZN_LINK"),
    hullAssessmentCheck: nullableText(row, "HULL_ASSESSMENT_CHECK"),
    submitHullAssessmentLink: nullableText(row, "SUBMIT_HULL_ASSESSMENT_LINK"),
    latestManualReminder: nullableText(row, "LATEST_MANUAL_REMINDER"), opsLink: nullableText(row, "OPS_LINK"),
    deliveredSinceDays: nullableNumber(row, "DELIVERED_SINCE_DAYS"),
    enteredSinceDays: nullableNumber(row, "ENTERED_SINCE_DAYS"),
    deliveryDate: nullableText(row, "DELIVERY_DATE"), status: text(row, "STATUS"), contractType: text(row, "CONTRACT_TYPE"),
    contract: nullableText(row, "CONTRACT"), minRedeliveryDate: nullableText(row, "MIN_REDEL_DATE"),
    maxRedeliveryDate: nullableText(row, "MAX_REDEL_DATE"), entryDate: nullableText(row, "ENTRY_DATE"),
    vesselType: text(row, "VESSEL_TYPE"), comment: nullableText(row, "COMMENT"),
  };
}

export async function fetchTfHullEvaluations(): Promise<TfHullEvaluationsResponse> {
  const response = await api.get<{ vessels: SnowflakeVessel[]; totalCount: number; lastRefreshedAt: string }>(
    `${apiUrl}/pbi/tf-hull-evaluations`,
  );

  return { ...response.data, vessels: response.data.vessels.map(mapVessel) };
}
